/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Video from 'components/Video/Video';
import Statement from '../Statement/Statement';
import './StatementVideo.scss';

/**
 * This is the StatementVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function StatementVideo({ statement, video }) {
  return (
    <div className="statement-video">
      <Statement>{statement}</Statement>
      <div className="video-container">
        <Video {...video} />
      </div>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
StatementVideo.propTypes = {
  statement: PropTypes.string,
  video: PropTypes.object.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
StatementVideo.defaultProps = {
  statement: '',
  video: {},
};

export default StatementVideo;
